// extracted by mini-css-extract-plugin
export default {"custom-table":"InvoiceWarningModal_custom-table__bKMVK"};